import { render, staticRenderFns } from "./HsabNotionalDashboard.vue?vue&type=template&id=565aeb46&scoped=true"
import script from "./HsabNotionalDashboard.vue?vue&type=script&lang=ts"
export * from "./HsabNotionalDashboard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565aeb46",
  null
  
)

export default component.exports